import Loader from '@components/framework/loader/Loader';
import PdfViewer from '@components/system/PdfViewer/PdfViewer';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import React from 'react';
interface ViewConsentFormDialogProps {
  open: boolean;
  isLoading: boolean;
  onClose?: (response: string) => void;
  file?: any;
  title?: string;
  description?: null | string;
}
const ViewConsentFormDialog = (
  props: ViewConsentFormDialogProps
): React.ReactElement => {
  const {
    open,
    isLoading,
    onClose,
    file,
    description
    // title
  } = props;
  const handleClose = React.useCallback(
    (response: 'confirm' | 'cancel') => {
      if (typeof onClose === 'function') {
        onClose(response);
      }
    },
    [onClose]
  );
  // **FIXME: need to render the HTML content inside the dialog content here **/
  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth={'lg'}
      fullWidth={true}
      open={open}
      onClose={handleClose}>
      <DialogTitle disableTypography>
        {
          // title //
        }
      </DialogTitle>
      <DialogContent dividers>
        {isLoading && <Loader />}
        {!isLoading && file && <PdfViewer file={file} />}
        {!isLoading && !file && description}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => handleClose('confirm')}
          color="primary"
          variant={'contained'}>
          {'Close'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewConsentFormDialog;
